export function subtractNumbersIfDefined(minuend: number | undefined, subtrahend: number | undefined): number | undefined {
    if (minuend === undefined) {
        return undefined;
    }

    return minuend - (subtrahend ?? 0);
}
